import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { RequireAuth, RequireAdmin } from './components/guards';
import AppLayout from './components/AppLayout';

// Lazy-loaded routes: each page (and its heavy deps — RJSF for the wizard,
// the DataGrid for the list) becomes its own chunk, loaded only when visited.
const LoginPage = lazy(() => import('./pages/LoginPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const InstancesPage = lazy(() => import('./pages/InstancesPage'));
const InstanceDetailPage = lazy(() => import('./pages/InstanceDetailPage'));
const DeployWizardPage = lazy(() => import('./pages/DeployWizardPage'));
const TypesPage = lazy(() => import('./pages/TypesPage'));
const CustomersPage = lazy(() => import('./pages/CustomersPage'));
const UsersPage = lazy(() => import('./pages/UsersPage'));

function PageFallback() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
      <CircularProgress />
    </Box>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="instances" element={<InstancesPage />} />
          <Route
            path="instances/new"
            element={
              <RequireAdmin>
                <DeployWizardPage />
              </RequireAdmin>
            }
          />
          <Route path="instances/:id" element={<InstanceDetailPage />} />
          <Route path="types" element={<TypesPage />} />
          <Route
            path="customers"
            element={
              <RequireAdmin>
                <CustomersPage />
              </RequireAdmin>
            }
          />
          <Route
            path="users"
            element={
              <RequireAdmin>
                <UsersPage />
              </RequireAdmin>
            }
          />
        </Route>
      </Routes>
    </Suspense>
  );
}
